import { render, staticRenderFns } from "./callTemplate.vue?vue&type=template&id=18e10798"
import script from "./callTemplate.vue?vue&type=script&lang=js"
export * from "./callTemplate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports